<template>
  <div class="logos">
    <router-link to='/' class="nav__logo logo__link">
      <img v-bind:src="this.$store.state.s3Link + require('./assets/tremfya-logo.svg')" alt="" class="logos__tremfya">
    </router-link>
    <router-link to='/' class="nav__logo logo__link">
      <img v-bind:src="this.$store.state.s3Link + require('./assets/MPR-Logo.svg')" alt="" class="logos__fact-pack">
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'logos'
};
</script>

<style lang="scss">
.logos {
  width: 100%;
  pointer-events: none;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  margin: 0 auto;
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  z-index: 999;
  height: 45px;
  @include media('<desktop') {
    width: 90%;
    max-width: 950px;
    padding-right: 0;
    padding-left: 0;
  }
  @include media('<tablet') {
    padding-top: 8px;
    padding-bottom: 8px;
  }
  @include media('>xlargeDesktop') {
    padding: 30px;
  }
  &__tremfya {
    pointer-events: all;
    width: 122px;
    height: 40px;
    @include media('>xlargeDesktop') {
      width: 162px;
      height: 50px;
    }
    @include media('<tablet') {
      width: 78px;
      height: 30px;
    }
  }
  &__fact-pack {
    pointer-events: all;
    width: 122px;
    height: 40px;
    @include media('>xlargeDesktop') {
      width: 162px;
      height: 50px;
    }
    @include media('<tablet') {
      width: 82px;
      height: 25px;
    }
  }
  //background-image: linear-gradient(-90deg, #F4B834 19%, #FFCC49 47%);
}
</style>
